<template>
  <div v-loading="loading" :key="chartKey">
    <apexchart type="line" :options="options" :height="400" :series="series" />
  </div>
</template>
<script>
  export default {
    data() {
      return {
        options: {
          stroke: {
            curve: 'smooth',
            width: [1, 3],
          },
          dataLabels: {
            enabled: false
          },
          legend: {
            horizontalAlign: 'left',
            offsetX: 40
          },
          yaxis: [{
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#008FFB'
            },
            labels: {
              formatter: val => {
                return (parseFloat(val).toFixed(2))
                .replace(/\D00$/, '') + ' Ft';
              }
            }
          }, {
            min: 0,
            max: 100,
            opposite: true,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#008FFB'
            },
            labels: {
              formatter: val => {
                return (parseFloat(val).toFixed(2))
                  .replace(/\D00$/, '') + ' %';
              }
            }
          }],
        },
        series: [{
          name: 'Nettó',
          type: 'column',
          data: []
        }, {
          name: 'Görgetett %',
          type: 'line',
          data: []
        }],
        chartKey: 0
      }
    },

    computed: {
      pareto() {
        return this.$store.getters['pareto/pareto'];
      },
      loading() {
        return this.$store.getters['pareto/loading'];
      }
    },

    watch: {
      pareto(newVal) {
        this.setChartData(newVal);
      }
    },

    async mounted() {
      if(!this.pareto.length) {
        await this.$store.dispatch('pareto/fetchAll');
      }
    },

    methods: {
      setChartData(data) {
        this.series[0].data = [];
        this.series[1].data = [];
        data.forEach(shop => {
          this.series[0].data.push({
            x: shop.name,
            y: shop.net_sum || 0,
          });
          this.series[1].data.push({
            x: shop.name,
            y: shop.percent_rolling || 0,
          });
        });
        this.chartKey++;
      }
    }
  }
</script>
